module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v("2")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-6",
      "title": "2 Don’t Answer Why"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v("Don’t Answer Why"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Most people die of the cure, not the disease.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Molière, "), _c('i', [_vm._v("The Miser and Other Plays")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("You have kept count of my tossings;put my tears in your bottle.Are they not in your book?")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+56%3A8&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 56:8")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The world is everything that is the case. . . .Whereof one cannot speak, thereof one must be silent.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Ludwig Wittgenstein, "), _c('i', [_vm._v("Tractatus Logico-Philosophicus")])]), _vm._v(" "), _c('p', {
    staticClass: "dingbat"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/dingbat_c.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "first-words"
  }, [_vm._v("I need not debate the realities of evil")]), _vm._v(" and suffering in this world: who can deny them? Nor will I argue for God’s existence, since I assume this to be the case. I do not think we must choose between affirming the reality of God and confessing the pain of human suffering. We can work forward from the view that both are true. We can acknowledge the struggle of being a follower of Yahweh, the creator of heaven and earth, and having to deal with suffering as it is: real, tragic, and heartbreaking.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To give a partial explanation of why I start at this point, we can take half a step backward to ask why using theodicy (defending God’s goodness) in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page18",
      "title": "18"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v("circumstances of suffering is less than useful. This exercise will hopefully improve our ministry to those who suffer.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("When Philosophers Should Be Silent")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Gottfried Wilhelm von Leibniz (1646–1716) famously wrote a treatise titled "), _c('i', [_vm._v("Theodicy")]), _vm._v(", in which he aimed to reconcile God’s perfection with the intractable problem of evil. Theodicies normally attempt to make sense of the apparent tension between human misery and the existence of an all-powerful, wholly good, and wise deity: how can there be so much pain in this world if such a God exists?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Writing in the years after the horrific Lisbon earthquake of 1755, in which tens of thousands died in just three days, Voltaire wrote "), _c('i', [_vm._v("Candide")]), _vm._v(" as a parody of philosophies that tried to make sense of pain. His infamous character Dr. Pangloss reflects Leibniz’s philosophy. Despite endless injustices and the most gruesome situations happening all around the characters, Pangloss’s constant mantra is that this is the “best of all possible worlds.” The novel made Leibniz’s theodicy look naive at best and cruelly absurd at worst.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("While the philosopher may convince his audience that the problem of suffering does not logically rule out the existence of a wholly good God, that view remains a great distance from the reality of faith in the God and Father of our Lord Jesus Christ and the foot of the cross. Only from that location at Golgotha will all of these questions be transformed, and only from that position might a truly Christian “explaining of the ways of God” occur.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Even if we had in hand a theodicy that made sense, such dispassionate philosophical explanations leave us empty when we walk in the fire and ashes of genuine suffering."), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1525",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("1")])]), _vm._v(" While there is a time to carefully dissect these philosophical problems, that time is not normally with those who are suffering. Such clinical reflections don’t tend to help but often cause more pain to those who mourn and ache. Theodicies don’t naturally belong in the home of the afflicted, even if they do need careful attention in the classroom.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Alvin Plantinga, one of the great American philosophers in the last seventy-five years, is also a Christian. He has written extensively on knotty intellectual challenges associated with faith, evil, human agency, and the like. While he insists that the problem of evil cannot preclude or even render improbable the existence of God, he also recognizes the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page19",
      "title": "19"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v("difference between a problem in thought and a problem in life. “Of course, suffering and misfortune may nonetheless constitute a problem for the theist,” but not a logical problem. Instead, the theist faces an existential and religious difficulty."), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1526",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When a person faces grave sorrow in their own life or in the life of one they dearly love, Plantinga affirms that it can be profoundly difficult even for the believer to maintain a proper posture before God. “Faced with great personal suffering or misfortune, he may be tempted to rebel against God, to shake his fist in God’s face, or even to give up belief in God altogether.” When suffering provokes a rejection of God, the issue is not primarily intellectual but “a problem of a different dimension. Such a problem calls, not for philosophical enlightenment, but for pastoral care.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1527",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("3")])]), _vm._v(" The questions people ask amid suffering may have the same wording as academic problems, but they are not the same questions; the subtext here is not theoretical curiosity but guilt, isolation, fear, and often a distorted view of God.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Indeed, when problems move from the hypothetical to the personal, they look and feel different. John S. Feinberg had for years devoted himself to a thorough philosophical and theological inquiry into the problem of evil."), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1528",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("4")])]), _vm._v(" Yet his understanding of the problem changed when his wife was diagnosed with Huntington’s chorea, a rare genetically transmitted disease that involves premature deterioration of nerve cells within the brain. Over time, the disease creates both psychological and physical trauma as the afflicted one loses control of certain bodily movements, often faces depression, and experiences severe memory loss. Eventually it can result in hallucinations and even paranoid schizophrenia. To make matters worse, Huntington’s could be passed genetically to their children.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("His meticulous answers and well-researched publications offered no real comfort to him in the face of this news and the difficult life they began to face. Careful arguments about human agency, contingency, and evil did not give hope or rest. It was not that his previous philosophical efforts were unwise or wrong, but they did not reach the places of his and his family’s pain. The theories could not plumb the depths of human sorrow. They needed pastoral care. They needed the quiet presence of others around them. They needed glimpses of God in his goodness and love, truths often only made believable through personal tenderness and gentle grace extended to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page20",
      "title": "20"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v("them by others. This family needed the warmth of God’s presence rather than the cool calculations of logical deductions.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("How the Church Responds to Suffering")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("John Swinton, in his excellent book "), _c('i', [_vm._v("Raging with Compassion")]), _vm._v(", observes that these attempts to justify God and explain evil or suffering are largely irrelevant to those in the midst of suffering and can actually cause more problems than they solve. Justifications of God had their origins in an Enlightenment context that held rationality and science to have the highest values and orthodox Christian ideas to have little or none. In such an atmosphere, even Christians were tempted to defend God on Enlightenment terms."), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1529",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("5")])]), _vm._v(" This framework allowed all questions, but it also put its own requirements on answers it considered to be valid. Prominent among these were the assumptions that (1) the critical scholars were working from a neutral point of view, (2) educated European standards of reason and justice were both universal and clearly apprehended by the critical scholars, and (3) they were capable of rising above and comprehending all the relevant elements of the problem to formulate a coherent set of applicable universal rules. Such a framework profoundly skewed how one approached these questions.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Both testaments of the Bible ask and address deep and difficult questions about pain, suffering, the apparent triumph of evil, and the apparent absence of God in times of stress. We see this most especially in the psalms. They contain multiple examples of lament and struggle, and orthodox Christian theology follows that path. Augustine and others wrote extensively about the presence of evil in a world governed by a good and gracious sovereign Lord. Yet their approach was not from a position of supposed neutrality or assuming that God was no more than another piece of a puzzle, subject to human judgment. They approached the question from a starting point of faith, and the problem for them was deeper and more difficult because of that. Alasdair MacIntyre, for example, wonders why these issues were not previously seen as “an obstacle to belief,” even though these Christians saw the problem of evil as clearly and deeply as any Enlightenment freethinker."), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1530",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("6")])]), _vm._v(" The difference between an Augustine and a Voltaire is not that the believer was credulous or superficial and the unbeliever a more rigorous thinker. The eighteenth century did not discover new pieces to the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page21",
      "title": "21"
    }
  }), _vm._v("puzzle that were unknown to the fourth century. The difference now was that expectations and assumptions were reshaped. Reasons were demanded and justifications required because the culture decided that they could put God under the microscope along with everything else. It is not that pre-Enlightenment approaches were perfect and without shortcomings. Yet a significant shift seems to occur after the Enlightenment, which made it difficult for us to confess the limits of our understanding—if we don’t know something, there "), _c('i', [_vm._v("must")]), _vm._v(" be a discoverable answer. Post-Enlightenment Europe decided that it could even fully understand transcendental realities in contemporary terms and sensible formulas. But the psalms, which are full of struggle, do not point us to answers and formulas. Hope? Yes. Answers? No. The psalms orient us to God. Our hope is in him who made and redeemed heaven and earth, not in our own intellectual acuity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the past, believers fully understood that evil and suffering existed. It was their place, as the people of God, to resist the evil when they could, and to mourn and lament the brokenness that they could not overcome. In fact, as we will see, their willingness to lament and hope amid their trouble was part of their answer to the suffering. The problem of evil was not so much a philosophical difficulty for pre-Enlightenment believers but a “practical challenge for the Christian community.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1531",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("7")])]), _vm._v(" How do we live in God’s compromised world? Ancient Christians responded with a set of practices and ways of living together with grace, solidarity, and promise amid the pain. These ways were not academic answers, but they were answers all the same. Different questions are being asked. The question we usually focus on is, why does evil exist? You can employ a theory for that. If the question instead is, how do we live?, then theories don’t really satisfy. Practices—not theories—become most relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the third chapter of Job, for example, the sufferer responds to his situation with heartfelt lament. And his lament is not in isolation but in the context of his closest relationships, namely, with his wife and friends. In their presence he turns this lament toward God in a way that shows his ultimate trust in his Creator-Redeemer. The other laments we read in the Scriptures present this same combination of detailed realism regarding discomfort, pain, and complex fears, and the conviction that God is present, powerful, wise, and good. They are as convinced that this is the God they "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page22",
      "title": "22"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _vm._v("have to deal with as they are of the reality of their suffering. They believe in a God who is not only holy but whose holiness is always characterized by compassion and grace; these attributes thoroughly define one another and are never in opposition. They see God not as removed from the earthly details of their lives but intimately and interestedly involved in them. Having such a worldview, they see it as a matter of course that lament is so often a response to suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("With the Enlightenment, Christians were often seduced into treating God not as their loving Father and covenant-keeping Lord but as a mental construct. Those Christians who accepted the abstract framework for discourse assumed by unbelievers (like Voltaire) lost the ground of their own proper theology, namely, the concrete invasion of history by this particular God. This framework, like a distorting lens, reshaped how people saw God and evil. When guided by the need for justifications and answers, growing Christian attempts to “explain the ways of God” tended to foster distortions, especially in pastoral situations. Swinton highlights three of the most common consequences."), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1532",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("8")])]), _vm._v(" First, such explanations, by trying to integrate evil as part of the world, often end up justifying or rationalizing evil rather than confessing and naming it. Too often when Christians start to defend God in this way, they end up calling evil or suffering “good.” Second, when people mistake theodicies for pastoral care, the voice of the sufferer is often silenced. Rather than offering the comforting presence of compassionate listening, these abstractions smother the wounded with useless and often inaccurate explanations. This works a form of violence against the hurting one, whether unintentional or not. And finally, these attempts to justify and explain "), _c('i', [_vm._v("why")]), _vm._v(" the evil has occurred can actually become evil in themselves, promoting further suffering rather than providing genuine comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("How often have well-intentioned ministers or friends tried to explain away a particular death, disease, or worse by an uninformed appeal to God’s purposes? Do any of us really know why a particular event happens? Claims to provide the reason for a specific experience of suffering abound: divine discipline, for the purpose of church renewal, to bring a watching nurse or neighbor to salvation, or to foster personal humility. Unfortunately, all these claims are made without true knowledge of exactly why something is happening. Even if these suggestions contain an element of truth, we are not in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page23",
      "title": "23"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _vm._v("a position to unpack the mind of God regarding such mysteries. What happens if the nurse who professes faith later abandons that faith or the apparent church renewal quickly fades away? Resting our faith on such connections can actually prove to be far more hazardous than most people realize. Such explanations assume that some good outcome can nullify or justify the pain, but this is not so. A tragedy is still a tragedy; pain is still pain, even if some insight is gained in the process. We may hope that God has reasons for allowing suffering in his world, but that is very different from thinking we have access to those reasons or can understand why a particular experience of suffering is taking place.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_6"
    }
  }, [_vm._v("Don’t Explain, but Do Listen and Love")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Pastors and friends are not called to explain away the pain or to try to give moral lessons for why a particular event is happening. We simply are not privy to such information. While God can and does bring about good through our suffering, that is not the same thing as knowing why God allows it. Nor is it the same thing as saying that God thinks our suffering is good. If we believe that God thinks our physical suffering is essentially good, we misunderstand the Creator and Redeemer, and we are brought to the temptation of having hard thoughts about God, believing him to be more like a dis­passionate scientist or a cruel tyrant rather than a loving Father. While it is true that amid our fallen world God can and does work through our pain and suffering, that does not mean he delights in our discomforts. And it does not mean that we can substitute theoretical reasoning for justified lament.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("All of us will face times of physical illness, disease, and pain. In such times we do not normally need philosophical axioms—as important as they can be to legitimate philosophical investigation."), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1533",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("9")])]), _vm._v(" We need words and ears that understand suffering, that can handle honesty, vulnerability, and questions, and that know how to bring the wounded to sustaining faith, hope, and love.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To understand God and his work in our lives better, we need to recognize and deal with our limits, naiveté, and the complexity of human suffering. This includes recognizing that our post-Enlightenment culture has distorted our view of God and reassessing what it means to walk through a painful world with a loving Lord. We will need to learn afresh what it means to point people to Jesus and his kingdom, but not as a slogan, not as a quick fix, not "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page24",
      "title": "24"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _vm._v("as a superficial answer. We must point to the profound and redemptive compassion of Jesus, the Son of God, who healed the sick and entered into genuine human suffering and even death by crucifixion. His life, death, and resurrection must continually reshape how we view the cosmos, our place and even our suffering within it, and the God we believe in.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_7"
    }
  }, [_vm._v("Developing Pastoral Sensitivity and Theological Instincts")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("This book aims to provide reflections that will prove helpful to some who are wrestling with personal pain and suffering, but it also hopes to offer counsel to those who are walking alongside loved ones who are in the midst of the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Loving well those facing the great trials of life requires Christians to develop both "), _c('i', [_vm._v("pastoral sensitivity")]), _vm._v(" and "), _c('i', [_vm._v("theological instincts")]), _vm._v(". Empathy and orthodoxy both matter. Benevolence and truth are meant to nourish one another, not to serve as two distinct options. When tenderheartedness and conviction are together, they bring life, but separated they can be disastrous. Discovering a perfect balance that allows a person to know the “right” response to every challenge is not the goal. Rather, Christians are those who experience the “faith and love that are in Christ Jesus” even as they cherish “the good deposit” handed down to them from the prophets, apostles, and through the ages ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Tim+1%3A12-14&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("2 Tim 1:12-14")]), _vm._v("). We cannot rest in the good news of Christ if we devalue the truths of sacred Scripture, but we also need to value experience if those truths are going to be applied and understood in any meaningful way.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Rightly understood, "), _c('i', [_vm._v("doing")]), _vm._v(" theology is more often like farming than it is like stacking doctrinal bricks. Theology is lived; it is not regimentally constructed. Like a gardener studying the soil over many years and watching the clouds in the sky each day, the Christian seeks to develop wise theological instincts so they may be able to know when to plant, when to uproot, when to water, and when to rest. Every season brings new challenges and fresh promises. Cultivating applied theological instincts is therefore inevitably a bit messy. You have to get your hands in the mud. Gardeners must discover the kinds of things that affect their crops’ growth—often a plant’s health depends on much more than the untrained observer realizes. Does the garden need more protection from the sun? What is in the soil? Funny enough, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page25",
      "title": "25"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _vm._v("sometimes you discover more nitrogen may be needed—more manure! Are there rocks buried where the roots need expansion? Is there too much rain? Too little? Are there ravenous animals around who will eat whatever growth occurs as fast as it shows up? How might environmental factors shape the plant, for better or worse? We need to recognize different seasons, different threats, and different possibilities, and then act according to that information. To prepare a garden always the same, never asking about changing conditions, is not only naive but risks losing your harvest in the long term.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To develop a theology of suffering, we can’t simply talk about suffering! Doctrines from various places—sometimes on the surface appearing un­related—need to be explored. Consider pain and the fall? Yes. But consider the goodness of creation. Consider individual fears? Yes. But consider the metaphysics of the community as well. Reflect on resurrection and hope? Absolutely. But also confess the cross, tragedy, and struggle.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Deliberately developing our theological instincts is deeply valuable, for it can help illumine the dark paths we find ourselves walking down. Paths need to be traveled, images need to be considered, songs need to be sung, silence needs to be observed. God must be present, sat with, listened to, and engaged. This takes us back to pastoral sensitivity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Only when we begin to see that theology is not merely about repeating back answers but instead more like caring for a garden can we care well for others. Good gardeners have been trained to pay attention to the soil in their hands and not just the instructions in a book. From the book they have learned about soil, what is needed, what to add, and how to care for it. But in the end, nothing can replace examining the dirt itself, for no two patches of the land are the same.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Each person is coming from a different circumstance, with specific challenges and needs, with individual strengths and temptations. Part of loving well is figuring out what response is needed and appropriate in a given circumstance (see "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Jude+22-23&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Jude 22-23")]), _vm._v("). This is where theological instincts and pastoral wisdom come together.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To be pastoral does "), _c('i', [_vm._v("not")]), _vm._v(" mean earning money for working in a church. Throughout Christian history God’s people have always been thankful for those with pastoral gifts among them—whether women or men, ordained or not, young or old, rich or poor. "), _c('i', [_vm._v("Pastoral")]), _vm._v(" in this sense refers to the ability "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page26",
      "title": "26"
    }
  }), _vm._v("to give wise counsel, to know how to love well, provide necessary guidance, and in the end to help a fellow believer flourish under God’s grace and love, even as they seek to love their neighbor and serve God’s kingdom.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("So, pastoral wisdom requires not merely theological knowledge but shepherding abilities. You need to know the sheep. You need to know the person or people you are dealing with. It may sound cliché, but if we could only get past the knee-jerk Christian reaction of one size fits all, we might really be able to care for people.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There is no theological replacement for knowing people, their problems, the complexities, and the stories. That doesn’t mean you can’t say anything in general, but it does mean there is a world of difference between reading a book about gardening and actually gardening. There is a world of difference between reading a book about caring for people and actually caring for people. To theologize well, we need to love well. We need to care about anthropology (the study of humans) and not just theology (the study of God). Pastoral wisdom and theological instincts must go together. They must serve one another.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Attempts at pastoral wisdom without developed theological instincts quickly dissolve into mere moralism or a psychological cul-de-sac. Theological ideas divorced from pastoral wisdom quickly become harsh or even tyrannical principles that lack concrete expressions of love and grace. Let’s avoid choosing between these. Let’s grow in our knowledge and love of God even as we grow in our commitment to understand and care for one another. Orthodox theology and compassionate concern always belong together.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11744fcd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/10_ch2.vue
// module id = 78
// module chunks = 0